import styled from "styled-components";
import theme from "../../../../UI/theme";
import NewBadge from "../../../navigation/NewBadge";
import ArrowButton from "../../../UiComponents/buttons/ArrowButton";
import Card from "../../../UiComponents/Card"
import InnerCard from "../../../UiComponents/containers/InnerCard";
import InvisibleLink from "../../../UiComponents/InvisibleLink";

const NavigationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    :hover {
        cursor: pointer;
    }

    h4 {
        margin: 16px 0;
    }
`

const StyledCard = styled(InnerCard)`
    padding: 6px 16px;
`

const InstallationSettingsOverview = props => {

    return <Card>
        <h3>Installation View <NewBadge text={'Admin'}/></h3>

        <StyledCard>
            <InvisibleLink to={`/installation`}>
                <NavigationContainer>
                    <h4>My installation</h4>
                    <ArrowButton color={theme.colors.darkSpace60} />
                </NavigationContainer>
            </InvisibleLink>
        </StyledCard>
    </Card>
}

export default InstallationSettingsOverview;